var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui-form-field ui-form-field__bool ui-form-field__checkbox",
      class: _vm.rootClasses.concat([_vm.bemIf(_vm.isChecked, "is-checked")])
    },
    [
      _c("label", [
        _c(
          "input",
          _vm._g(
            _vm._b(
              {
                staticClass: "ui-form-field--input",
                attrs: { type: "checkbox" },
                domProps: { value: _vm.value },
                on: { change: _vm.onChange }
              },
              "input",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ui-form-field--label-wrap" }, [
          _c(
            "span",
            { staticClass: "ui-form-field--box" },
            [
              _vm._t(
                "default",
                [
                  _c("ui-icon", {
                    staticClass: "ui-form-field--box-icon",
                    attrs: { symbol: "checkmark", size: "small" }
                  })
                ],
                { mame: "icon" }
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui-form-field--label" },
            [_vm._t("label")],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm._t("messages")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ee022db", { render: render, staticRenderFns: staticRenderFns })
  }
}